import { render, staticRenderFns } from "./Drink.vue?vue&type=template&id=52e0d78c&scoped=true&"
import script from "./Drink.vue?vue&type=script&lang=js&"
export * from "./Drink.vue?vue&type=script&lang=js&"
import style0 from "./Drink.vue?vue&type=style&index=0&id=52e0d78c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e0d78c",
  null
  
)

export default component.exports